import React, { Component } from 'react';
import { connect } from "react-redux";
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grow from '@material-ui/core/Grow';
import CircularProgress from '@material-ui/core/CircularProgress';
import Cookies from 'universal-cookie';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Auth from '../../utils/Auth';
import CustomLanguageSelector from './CustomLanguageSelector';

const cookies = new Cookies();

const styles = theme => ({
    modal: {
        '& .MuiPaper-root': {
            width: '350px !important',
        }
    },
    modalTitle: {
        textAlign: 'center',
        backgroundColor: "rgb(203,65,2)",
        color: 'white',
        boxShadow: '0 1px 5px 0px black',
        '& .MuiTypography-root': {
            fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji',
        }
    },
    dialogContent: {
        minHeight: 100,
    },
    dialogContentText: {
        paddingTop: 10,
    }
});

class LanguageModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGoogleTranslateLoaded: false,
            currentLang: this.getLanguageFromCookie() || 'bg'
        };
        this.intervalCheckDuplicate = null;
        this.googleTranslateScript = null;
        this.hasGoogleTranslateInit = false; // Добавяме флаг за следи дали сме задали callback
    }

    getLanguageFromCookie = () => {
        const googtransCookie = cookies.get('googtrans');
        if (googtransCookie) {
            const parts = googtransCookie.split('/');
            if (parts.length > 2) {
                return parts[2];
            }
        }
        return null;
    };

    componentDidMount() {
        if (this.props.open && this.props.translationsType == 1) {
            this.initGoogleTranslate();
        }
    }

    componentDidUpdate(prevProps) {
        const { open, translationsType } = this.props;

        if (translationsType == 1) {
            Auth.removeCurrLang();

            if (open && !prevProps.open) {
                this.initGoogleTranslate();
            } else if (!open && prevProps.open) {
                this.cleanUpGoogleTranslate();
            }
        } else if (!open && prevProps.open) {
            this.cleanUpGoogleTranslate();
            this.setState({ isGoogleTranslateLoaded: false }); // Добавете този ред
        }

    }

    componentWillUnmount() {
        this.cleanUpGoogleTranslate();
    }

    initGoogleTranslate = () => {
        this.setState({ isGoogleTranslateLoaded: false }, () => {
            // Изчистваме само нашия скрипт, не всички Google елементи
            if (this.googleTranslateScript && document.body.contains(this.googleTranslateScript)) {
                if (document && document.body && this.googleTranslateScript && document.body.contains(this.googleTranslateScript)) {
                    // document.body.removeChild(this.googleTranslateScript);
                }
            }

            // Създаваме нов скрипт
            this.googleTranslateScript = document.createElement('script');
            this.googleTranslateScript.src = '//translate.google.com/translate_a/element.js?cb=gTranslateElemInit';
            this.googleTranslateScript.async = true;
            document.body.appendChild(this.googleTranslateScript);

            // Задаваме callback функция
            window.gTranslateElemInit = () => {
                if (!this.state.isGoogleTranslateLoaded) {
                    this.setState({ isGoogleTranslateLoaded: true }, () => {
                        this.createTranslateElement();
                        this.setupDuplicateChecker();
                    });
                }
            };
            this.hasGoogleTranslateInit = true;
        });
    };

    createTranslateElement = () => {
        const container = document.getElementById('gTanslateElem');
        if (!container) return;

        // Изчистваме само ако няма вече зареден преводач
        if (!container.querySelector('.goog-te-combo')) {
            container.innerHTML = '';

            try {
                new window.google.translate.TranslateElement({
                    pageLanguage: this.state.currentLang,
                    includedLanguages: 'bg,de,el,en,it,fr,es,pl,ro,ru,sr,tr,uk,no',
                    gaTrack: true,
                    gaId: 'UA-149580510-1'
                }, 'gTanslateElem');

                this.setCurrentLanguageFromCookie();
            } catch (error) {
                console.error('Грешка при инициализация:', error);
            }
        }
    };

    setCurrentLanguageFromCookie = () => {
        const currentLang = this.getLanguageFromCookie();
        if (currentLang) {
            const selectElement = document.querySelector('#gTanslateElem select');
            if (selectElement) {
                selectElement.value = currentLang;
                this.setState({ currentLang });
            }
        }
    };

    setupDuplicateChecker = () => {
        this.intervalCheckDuplicate = setInterval(() => {
            const translationSelects = document.querySelectorAll('#gTanslateElem select');
            if (translationSelects && translationSelects.length > 1) {
                for (let i = 1; i < translationSelects.length; i++) {
                    translationSelects[i].remove();
                }
            }
        }, 500);
    };

    cleanUpGoogleTranslate = () => {
        // Почистваме интервала
        if (this.intervalCheckDuplicate) {
            clearInterval(this.intervalCheckDuplicate);
            this.intervalCheckDuplicate = null;
        }

        // Почистваме само нашия скрипт
        if (this.googleTranslateScript && document.body.contains(this.googleTranslateScript)) {
            if (document && document.body && this.googleTranslateScript && document.body.contains(this.googleTranslateScript)) {
                // document.body.removeChild(this.googleTranslateScript);
            }
            this.googleTranslateScript = null;
        }

        // Почистваме callback
        if (this.hasGoogleTranslateInit && window.gTranslateElemInit) {
            try {
                delete window.gTranslateElemInit;
            } catch (e) {
                console.warn('Грешка при изтриване на gTranslateElemInit:', e);
            }
            this.hasGoogleTranslateInit = false;
        }

        this.setState({ isGoogleTranslateLoaded: false });
    };

    render() {
        const { classes, fullWidth = false, maxWidth = 'xs', open, translations, handleClose, translationsType, languages, currLangOnChange, currLang } = this.props;

        let langOptions = Object.values(languages).map(l => (
            <MenuItem key={l.id} value={l.code}>{l.name}</MenuItem>
        ));

        let trans = translationsType == 1 ? (
            <>
                * {translations.modals?.language_modal?.translations_may_not_be_accurate || ''}
                <div id="gTanslateElem" style={{ minHeight: '40px', display: 'none' }}></div>
                <br />
                <CustomLanguageSelector />
                {!this.state.isGoogleTranslateLoaded && (
                    <CircularProgress size={24} style={{ margin: '10px auto', display: 'block' }} />
                )}
            </>
        ) : (
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group" style={{ textAlign: 'center' }}>
                        <Select
                            style={{ width: '40%', height: 40 }}
                            onChange={currLangOnChange}
                            value={currLang}
                        >
                            {langOptions}
                        </Select>
                    </div>
                </div>
            </div>
        );

        return (
            <Dialog
                TransitionComponent={Grow}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={open}
                onClose={handleClose}
                aria-labelledby="max-width-dialog-title"
                className={classes.modal}
                data-class="dialog-container"
            >
                <DialogTitle id="max-width-dialog-title" className={classes.modalTitle} data-class="dialog-title-container">
                    {translations.pages?.change_language?.title || ''}
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <DialogContentText className={classes.dialogContentText} style={{ textAlign: 'center', lineHeight: 'initial', marginBottom: 0 }}>
                        {trans}
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ display: 'block' }}>
                    <Button onClick={handleClose} style={{ color: 'black', fontSize: 13 }}>
                        {translations.common?.close || ''}
                    </Button>

                    {translationsType == 1 && (
                        <Button
                            onClick={() => {
                                cookies.remove('googtrans', { path: '/' });
                                cookies.remove('googtrans', { domain: '.tabl.bg', path: '/' });
                                cookies.remove('tabl_translate_google', { path: '/' });
                                cookies.remove('tabl_translate_google', { domain: '.tabl.bg', path: '/' });
                                window.location.reload();
                            }}
                            style={{ color: '#FE6902', fontWeight: 'bold', float: 'right', fontSize: 13 }}
                            className="skiptranslate notranslate"
                            id="revert_translation"
                        >
                            {translations.modals?.language_modal?.back_to_default_lang || ''}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(connect()(LanguageModal));